export const NO_DATA_CHAR = '-';
export const NA_CHAR = 'N/A';
